// Platform configurations for FlowGen

export const Platform = {
  Facebook: 'Facebook',
  Instagram: 'Instagram',
  LinkedIn: 'LinkedIn',
  TikTok: 'TikTok',
  Twitter: 'Twitter',
  BlueSky: 'BlueSky'
};

// Platforms that support direct publishing via Composio
export const COMPOSIO_PLATFORMS = ['linkedin', 'facebook', 'instagram'];

// Platforms that require manual export (download image + copy caption)
export const MANUAL_PLATFORMS = ['twitter', 'tiktok', 'bluesky', 'youtube', 'threads', 'reddit', 'pinterest', 'mastodon'];

// Full platform configuration with metadata
export const PLATFORM_CONFIG = {
  twitter: {
    id: 'twitter',
    name: 'Twitter / X',
    icon: 'Twitter',
    color: 'bg-sky-500',
    textColor: 'text-sky-500',
    publishMethod: 'manual',
    charLimit: 280,
    tip: 'Short, punchy content with trending hashtags'
  },
  linkedin: {
    id: 'linkedin',
    name: 'LinkedIn',
    icon: 'Linkedin',
    color: 'bg-blue-600',
    textColor: 'text-blue-600',
    publishMethod: 'composio',
    charLimit: 3000,
    tip: 'Professional tone, industry insights, thought leadership'
  },
  facebook: {
    id: 'facebook',
    name: 'Facebook',
    icon: 'Facebook',
    color: 'bg-blue-500',
    textColor: 'text-blue-500',
    publishMethod: 'composio',
    charLimit: 63206,
    tip: 'Engaging stories, community focus, calls to action'
  },
  instagram: {
    id: 'instagram',
    name: 'Instagram',
    icon: 'Instagram',
    color: 'bg-gradient-to-br from-purple-500 via-pink-500 to-orange-400',
    textColor: 'text-pink-500',
    publishMethod: 'composio',
    charLimit: 2200,
    tip: 'Visual-first, lifestyle content, strategic hashtags'
  },
  tiktok: {
    id: 'tiktok',
    name: 'TikTok',
    icon: 'Video',
    color: 'bg-black',
    textColor: 'text-white',
    publishMethod: 'manual',
    charLimit: 2200,
    tip: 'Trendy, casual, hook in first 3 seconds'
  },
  bluesky: {
    id: 'bluesky',
    name: 'Bluesky',
    icon: 'Cloud',
    color: 'bg-sky-400',
    textColor: 'text-sky-400',
    publishMethod: 'manual',
    charLimit: 300,
    tip: 'Conversational, community-focused'
  },
  youtube: {
    id: 'youtube',
    name: 'YouTube',
    icon: 'Youtube',
    color: 'bg-red-600',
    textColor: 'text-red-600',
    publishMethod: 'manual',
    charLimit: 5000,
    tip: 'SEO-optimized descriptions, clear CTAs'
  },
  threads: {
    id: 'threads',
    name: 'Threads',
    icon: 'MessageCircle',
    color: 'bg-gray-800',
    textColor: 'text-gray-400',
    publishMethod: 'manual',
    charLimit: 500,
    tip: 'Conversational, text-focused content'
  }
};

// Helper to check if platform supports Composio
export const isComposioPlatform = (platform) => {
  return COMPOSIO_PLATFORMS.includes(platform?.toLowerCase());
};

// Helper to get platform config
export const getPlatformConfig = (platform) => {
  return PLATFORM_CONFIG[platform?.toLowerCase()] || null;
};

// Get all platforms as array
export const getAllPlatforms = () => {
  return Object.values(PLATFORM_CONFIG);
};
